/*
 * onlyQ Abo nach Warenkorbwert
 * Passt das Appstle Widget auf der Produktseite an das neue Abomodell an:
 * kein produktbezogener Abopreis mehr, der Vorteil ergibt sich aus dem Warenkorb.
 * Biegt ausserdem den Appstle Hilfelink auf die eigene onlyQ Aboseite um.
 * Stand 16.09.2026, Theme "ABO test".
 */
(function () {
  var HILFE_URL = '/pages/dein-abo';
  var HILFE_TEXT = 'So funktioniert dein onlyQ Abo';

  var STUFEN = [
    { ab: 'ab 40 €', wert: '15 %' },
    { ab: 'ab 60 €', wert: '21 %' },
    { ab: 'ab 85 €', wert: '25 %' },
    { ab: 'ab 130 €', wert: '27 %' },
    { ab: 'ab 260 €', wert: '30 %' }
  ];

  var FAKTEN = [
    'Maßgeblich ist der Listenwert aller Aboartikel in deinem Warenkorb, auch bei mehreren Stück.',
    'Unter 40 € läuft dein Abo zum Listenpreis, ohne Vorteil und mit Versandkosten.',
    'Ab 40 € ist jede Abolieferung versandkostenfrei.',
    'Mindestlaufzeit sind 6 Lieferungen, geliefert wird jeden Monat. Pausieren kannst du bis zu zwei Monate.',
    'Deine Stufe wird beim Abschluss festgehalten und steigt, sobald du während der Laufzeit aufstockst.',
    'Ins Abo kommen Einzelartikel, keine Sets. Wenn du zwei Stück willst, nimm den Artikel zweimal.'
  ];

  var NOTE = 'Der Preisvorteil hängt an der Laufzeit. Kündigst du vor der sechsten Lieferung, verrechnen wir den Vorteil der bereits gelieferten Sendungen nach.';

  var DESC = 'Preis je Artikel wie im Einzelkauf, dein Vorteil wird im Warenkorb abgezogen.';

  function baueBox() {
    var box = document.createElement('div');
    box.className = 'oq-abo';
    box.setAttribute('data-oq-abo', 'staffel');

    var stufen = STUFEN.map(function (s) {
      return '<li><span>' + s.ab + '</span><b>' + s.wert + '</b></li>';
    }).join('');

    var fakten = FAKTEN.map(function (f) {
      return '<li>' + f + '</li>';
    }).join('');

    box.innerHTML =
      '<details class="oq-abo__box">' +
      '<summary>Dein Abo Vorteil, 15 bis 30 Prozent nach Warenkorb</summary>' +
      '<div class="oq-abo__body">' +
      '<ul class="oq-abo__staffel">' + stufen + '</ul>' +
      '<ul class="oq-abo__facts">' + fakten + '</ul>' +
      '<p class="oq-abo__note">' + NOTE + '</p>' +
      '<p class="oq-abo__more"><a href="' + HILFE_URL + '">' + HILFE_TEXT + '</a></p>' +
      '</div>' +
      '</details>';

    return box;
  }

  function linkUmbiegen() {
    var links = document.querySelectorAll('a.appstle_subcription_link, a[href*="appstle.com/subscription-article"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.getAttribute('data-oq-abo') === 'link') continue;
      a.setAttribute('href', HILFE_URL);
      a.removeAttribute('target');
      a.textContent = HILFE_TEXT;
      a.setAttribute('data-oq-abo', 'link');
    }
  }

  function anpassen() {
    linkUmbiegen();

    var wrapper = document.querySelector('.appstle_subscription_wrapper');
    if (!wrapper || !wrapper.parentNode) return;

    var desc = wrapper.querySelector('.appstle_subscription_description_text');
    if (desc && desc.getAttribute('data-oq-abo') !== 'desc') {
      desc.textContent = DESC;
      desc.classList.add('oq-abo-desc');
      desc.setAttribute('data-oq-abo', 'desc');
    }

    if (!wrapper.parentNode.querySelector('[data-oq-abo="staffel"]')) {
      wrapper.parentNode.insertBefore(baueBox(), wrapper.nextSibling);
    }
  }

  function start() {
    anpassen();
    if (!document.body || typeof MutationObserver === 'undefined') return;
    var timer = null;
    new MutationObserver(function () {
      if (timer) return;
      timer = window.setTimeout(function () {
        timer = null;
        anpassen();
      }, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
